import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PropertyForm } from "../components/realestate/PropertyForm";
import { useAccounts } from "../hooks/accounts";
import { useCreateProperty } from "../hooks/realestate";
import type { CreatePropertyInput } from "../lib/realestate";
import { mapRealEstateError } from "../lib/realestate-errors";

export function RealEstateNew() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const accounts = useAccounts({ active: "true" });
  const create = useCreateProperty();
  const [serverError, setServerError] = useState<string | undefined>();

  async function handleSubmit(input: CreatePropertyInput) {
    setServerError(undefined);
    try {
      const created = await create.mutateAsync(input);
      nav(`/realestate/${created.id}`);
    } catch (err) {
      const code =
        err &&
        typeof err === "object" &&
        "code" in err &&
        typeof (err as { code: unknown }).code === "string"
          ? (err as { code: string }).code
          : undefined;
      setServerError(code ? t(mapRealEstateError(code)) : t("errors.unknown"));
    }
  }

  return (
    <div className="space-y-4 max-w-xl">
      <h1 className="text-2xl font-bold">{t("realestate.new.title")}</h1>
      <PropertyForm
        mode="create"
        accounts={accounts.data?.accounts ?? []}
        onSubmit={(input) => handleSubmit(input as CreatePropertyInput)}
        submitting={create.isPending}
        serverError={serverError}
      />
    </div>
  );
}
